"use strict";

var _toConsumableArray = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __await = this && this.__await || function (v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
};

var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;

  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }

  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }

  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }

  function fulfill(value) {
    resume("next", value);
  }

  function reject(value) {
    resume("throw", value);
  }

  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Palette = void 0;

var LABColor_1 = require("./LABColor");

var Color_1 = require("./Color");
/**
 * The `Palette` class to generate a palette with specified settings
 * and extract a subset as color swatches.
 */


var Palette = /*#__PURE__*/function () {
  /** Creates a new palette with provided settings */
  function Palette(settings) {
    _classCallCheck(this, Palette);

    this.settings = {
      lightness: settings.lightness === undefined ? 0.65 : Math.max(0, Math.min(1, settings.lightness)),
      lightnessVariation: settings.lightnessVariation === undefined ? 0 : Math.max(0, Math.min(1, settings.lightnessVariation)),
      minGrayness: settings.minGrayness === undefined ? 0 : Math.max(0, Math.min(1, settings.minGrayness)),
      maxGrayness: settings.maxGrayness === undefined ? 2 : Math.max(0, Math.min(2, settings.maxGrayness)),
      granularity: settings.granularity === undefined ? 50 : Math.max(10, settings.granularity),
      abRange: settings.abRange === undefined ? 1.3 : Math.max(0, Math.min(2, settings.abRange))
    };
    this.generateClusterPromise = this.generateGamutClusterAsync();
  }
  /**
   * Returns a promise with Gamut points resolved when all points are calculated.
   */


  _createClass(Palette, [{
    key: "gamut",
    value: function () {
      var _gamut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.gamutCluster !== undefined && this.gamutCluster !== null)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", new Promise(function (resolve) {
                  return resolve(_this.gamutCluster);
                }));

              case 4:
                return _context.abrupt("return", this.generateClusterPromise.then(function (cluster) {
                  _this.gamutCluster = cluster;
                  return cluster;
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function gamut() {
        return _gamut.apply(this, arguments);
      }

      return gamut;
    }()
    /**
     * Generates a random set of swatches within the palette's gamut.
     * @param colorsCount - The number of colors to be generated.
     */

  }, {
    key: "swatches",
    value: function () {
      var _swatches = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(colorsCount) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.gamut().then(function (cluster) {
                  var swatches = new Array();
                  var first = Math.round(Math.random() * cluster.length);
                  swatches.push(cluster[first]);

                  for (var i = 0; i < colorsCount - 1; i++) {
                    swatches.push(_this2.findNextColor(swatches, cluster));
                  }

                  return swatches;
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function swatches(_x) {
        return _swatches.apply(this, arguments);
      }

      return swatches;
    }()
    /**
     * Expands provided set of swatches within the palette's gamut.
     * @param swatches - The original set of swatches.
     * @param colorsCount - The number of new colors to be generated.
     */

  }, {
    key: "more",
    value: function () {
      var _more = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(swatches, colorsCount) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(swatches.length > 0)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", this.gamut().then(function (cluster) {
                  var newSwatches = new Array();
                  var allSwatches = swatches.map(function (sw) {
                    return sw;
                  });

                  for (var i = 0; i < colorsCount; i++) {
                    var swatch = _this3.findNextColor(allSwatches, cluster);

                    allSwatches.push(swatch);
                    newSwatches.push(swatch);
                  }

                  return newSwatches;
                }));

              case 4:
                return _context3.abrupt("return", this.swatches(colorsCount));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function more(_x2, _x3) {
        return _more.apply(this, arguments);
      }

      return more;
    }()
    /**
     * Iteratively generates new swatches within the palette's gamut.
     */

  }, {
    key: "swatchIterator",
    value: function swatchIterator() {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function swatchIterator_1() {
        var gamut, firstIndex, firstColor, swatches, lastColor, distance, nextColor;
        return _regeneratorRuntime.wrap(function swatchIterator_1$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __await(this.gamut());

              case 2:
                gamut = _context4.sent;
                firstIndex = Math.round(Math.random() * gamut.length);
                firstColor = gamut[firstIndex];
                _context4.next = 7;
                return __await(firstColor);

              case 7:
                _context4.next = 9;
                return _context4.sent;

              case 9:
                swatches = [firstColor];
                lastColor = firstColor;
                distance = 1.0;

              case 12:
                if (!(distance > 0)) {
                  _context4.next = 24;
                  break;
                }

                nextColor = this.findNextColor(swatches, gamut);
                swatches.push(nextColor);
                distance = nextColor.LAB.distanceTo_00(lastColor.LAB);
                lastColor = nextColor;

                if (!(distance > 0)) {
                  _context4.next = 22;
                  break;
                }

                _context4.next = 20;
                return __await(nextColor);

              case 20:
                _context4.next = 22;
                return _context4.sent;

              case 22:
                _context4.next = 12;
                break;

              case 24:
              case "end":
                return _context4.stop();
            }
          }
        }, swatchIterator_1, this);
      }));
    }
    /**
     * Finds the next color to expand the swatches set within the palette's gamut.
     * Returns the point with maximum distance to all the colors in swatches.
     * @param swatches - The original set of swatches.
     * @param cluster - The cluster to look with-in.
     */

  }, {
    key: "findNextColor",
    value: function findNextColor(swatches, cluster) {
      var candidate = cluster[0];
      var maxDistanceSQ = 0;
      cluster.forEach(function (colorPoint) {
        var distances = swatches.map(function (swatchPoint) {
          return colorPoint.LAB.distanceTo_00(swatchPoint.LAB);
        });
        var minDistanceSQ = Math.min.apply(Math, _toConsumableArray(distances));

        if (minDistanceSQ > maxDistanceSQ) {
          candidate = colorPoint;
          maxDistanceSQ = minDistanceSQ;
        }
      });
      return candidate;
    }
    /**
     * Wraps the `generateGamutCluster` method into a Promise.
     */

  }, {
    key: "generateGamutClusterAsync",
    value: function generateGamutClusterAsync() {
      var _this4 = this;

      var promise = new Promise(function (resolve) {
        _this4.gamutCluster = _this4.generateGamutCluster();
        resolve(_this4.gamutCluster);
      });
      return promise;
    }
    /**
     * Generates a gamut cluster of paired colors in CIELAB (LAB) and RGB,
     * filtered by color points valid in RGB space and grayness constrains
     * (withing the range of [`minGrainess`, `maxGrayness`]).
     *
     * This method augments the `generatePointsCluster` method with lightness settings,
     * putting lightness equal to a random value within the range
     * [`lightness` - `lightnessVariation`/2, `lightness` + `lightnessVariation`/2].
     */

  }, {
    key: "generateGamutCluster",
    value: function generateGamutCluster() {
      var _this5 = this;

      var cluster = this.generatePointsCluster(this.settings.granularity);
      cluster = cluster.filter(function (p) {
        var d = _this5.distanceToGray(p);

        return d >= _this5.settings.minGrayness && d <= _this5.settings.maxGrayness;
      });
      var colorSpace = new Array();
      cluster.forEach(function (p) {
        var lightness = _this5.settings.lightness;

        if (_this5.settings.lightnessVariation > 0) {
          lightness += _this5.settings.lightnessVariation * (Math.random() - 0.5);
          lightness = Math.max(0, Math.min(1, lightness));
        }

        var labcolor = new LABColor_1.LABColor(lightness, p.a, p.b);
        var color = new Color_1.Color(labcolor);

        if (color.sRGB.isValidColor()) {
          colorSpace.push(color);
        }
      });
      return colorSpace;
    }
    /**
     * Calculate distance from color point to a zero-point (`a = b = 0`).
     * @param p - Origin point.
     */

  }, {
    key: "distanceToGray",
    value: function distanceToGray(p) {
      return Math.sqrt(p.a * p.a + p.b * p.b);
    }
    /**
     * Generate a grid of color points in AB-subspace, centered at `a = b = 0` and
     * the grid size [-`abRage`, +`abRange`] in each dimension.
     * @param granularity - Number of grid steps in each dimension.
     */

  }, {
    key: "generatePointsCluster",
    value: function generatePointsCluster(granularity) {
      granularity = Math.round(granularity);
      var cluster = new Array(granularity * granularity);
      var range = this.settings.abRange;

      for (var i = 0; i < granularity; i++) {
        for (var j = 0; j < granularity; j++) {
          cluster[i * granularity + j] = {
            a: range * 2 * i / (granularity - 1) - range,
            b: range * 2 * j / (granularity - 1) - range
          };
        }
      }

      return cluster;
    }
  }]);

  return Palette;
}();

exports.Palette = Palette;